import React from 'react';
import { Card, Box, HStack, Text } from '@chakra-ui/react';

interface LogoutMenuProps {
  onClick: () => void;
}

const LogoutMenu: React.FC<LogoutMenuProps> = ({ onClick }) => (
  <Card.Root w="full" variant="elevated" bg="white/80" borderRadius="2xl">
    <Card.Body p={0}>
      <Box
        as="button"
        w="full"
        py={3}
        px={4}
        onClick={onClick}
        _hover={{ bg: 'red.50' }}
        transition="background 0.2s"
        borderRadius="2xl"
      >
        <HStack justify="center">
          <Text fontSize="sm" fontWeight="medium" color="red.600">
            ログアウト
          </Text>
        </HStack>
      </Box>
    </Card.Body>
  </Card.Root>
);

export default LogoutMenu;
